import { useParams } from 'react-router-dom';
import React, { useEffect, useState, useRef } from 'react';
import { useAuth } from './AuthContext'; // Pas het pad aan naar je AuthContext
import './ConfigCompany.css'; // Importeer de bijbehorende CSS
import backicon from './Back Icon.png';
import icon_MyAccount from './My Account Icon.png';
import icon_Logout from './Logout Icon.png';
import icon_SwitchCompany from './Switch Company Icon.png';
import icon_MyProfile from './My Profile Icon.png';
import icon_Help from './Icon Help.png';
import icon_ConfigCompany from './Icon Config Company.png';
import './App.css';
import { useNavigate } from 'react-router-dom';
import { CSSTransition } from 'react-transition-group';
import api from './axios';


const popupMenuStyle = {
    position: 'absolute',
    backgroundColor: 'white',
    border: '1px solid grey',
    zIndex: 1000,
    padding: '10px',
    boxShadow: '5px 0px 10px rgba(0, 0, 0, 0.2)', // Rechtse schaduw
    transform: 'scale(1)', // Begin iets kleiner
    transition: 'transform 1s ease-in-out', // Overgangseffect
    borderRadius: '5px', // Afgeronde hoeken
  };
  
const iconStyle = {
    cursor: 'pointer', // Handcursor bij hover
    height: '4vh',
    margin: '5px 15px'
  };
  
const menuItemStyle = {
    display: 'flex',
    alignItems: 'center',
    margin: '5px 15px',
    whiteSpace: 'nowrap' // Voorkomt dat de tekst wordt afgebroken naar een nieuwe regel
  };


function ConfigCompany() {
    const { user, updateUser, companyName, companyId, logout } = useAuth();
    const [menu2Open, setMenu2Open] = useState(false);
    const menu2Ref = useRef(null);
    const navigate = useNavigate(); 
    const [activeMenu, setActiveMenu] = useState('users');  // Standaard is 'users' actief
    const [error, setError] = useState('');
    const [showErrorPopup, setShowErrorPopup] = useState(false);
    const [showPopupMessage, setShowPopupMessage] = useState(false);
    const [showHelpPopup, setShowHelpPopup] = useState(false);
    const [message, setMessage] = useState('');
    const [selectedCategory, setSelectedCategory] = useState('Support');
    const [Request_message, setRequestMessage] = useState("");
  

    const handleSendHelpButton = async (event) => {
      event.preventDefault();
      setShowHelpPopup(false);
  
      try {
        const { data } = await api.post('/api/requestforsupport/', {
          user_id:        user.id,
          user_email:     user.email,
          user_name:      user.name,
          company_id:     companyId,
          company_name:   companyName,
          Request_category: selectedCategory,
          Request_message:  Request_message,
          currentURL:       window.location.href
        });
  
        setMessage('Request for support sent successfully');
        setShowPopupMessage(true);
        setTimeout(() => setShowPopupMessage(false), 3000);
  
      } catch (err) {
        if (err.response?.status === 401) {
          await logout();
          setError('Session expired');
          setShowErrorPopup(true);
          setTimeout(() => setShowErrorPopup(false), 3000);
          navigate(`/login/${companyId}`);
          return;
        }
        setError(err.response?.data?.error || err.message);
        setShowErrorPopup(true);
        setTimeout(() => setShowErrorPopup(false), 3000);
      }
    };
    
    const handleMyProfile = () => {
      navigate('/my-profile');
    };
    
    const handleLogout = async () => {
      await logout();  
      navigate(`/login/${companyId}`);
    };

    const handleSwitchCompany = () => {
        navigate('/my-companies');
      };

      
      const handleClickOutside = (event) => {
        if (menu2Ref.current && !menu2Ref.current.contains(event.target)) {
          setMenu2Open(false);
        }
      };

      const handleMenu_Help = () => {
        setShowHelpPopup(true);
      };
    
      useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside);
        // Opruimen bij ontkoppeling
        return () => {
          document.removeEventListener('mousedown', handleClickOutside);
        };
      }, []); // Geen afhankelijkheden, alleen bij mounten en ontkoppelen

      useEffect(() => {    
        async function fetchData() {
          try {
            // Stel loading state in als je die hebt...
            // Roep je endpoint aan via axios-instance (cookies & interceptor vangen 401 af)
            const { data } = await api.get(
              `/api/getCompanyData/${user.id}/${companyId}`
            );
    
            // Hier verwerk je 'data' zoals voorheen...
            // bv. setSomething(data.something);
    
          } catch (err) {
            // Bij 401 behandelt je interceptor dat al, maar voor de zekerheid:
            if (err.response?.status === 401) {
              await logout();
              setError('Session expired');
              setShowErrorPopup(true);
              setTimeout(() => setShowErrorPopup(false), 3000);
              navigate(`/login/${companyId}`);
            } else {
              console.error('Error fetching company data:', err);
            }
          } finally {
            // Zet loading=false als je dat bijhoudt
          }
        }
    
        if (user && companyId) {
          fetchData();
        }
      }, [user, companyId, companyName, logout, navigate]);
    

      // Als de gebruiker niet is ingelogd, render dan niets
    if (!user) 
    {
        //+navigate('/login/'+localStorage.getItem('companyId')); // Redirect naar de loginpagina // Redirect naar de loginpagina
        return null;
    }

    // Toon 'access denied' de pagina als de gebruiker geen Admin (1) of Member (2) is
    if (!user || (user.company_roleId !== 1 && user.company_roleId !== 2)) {
      return "Access denied";
    }

  return (
    <CSSTransition
      in={true} // Deze waarde verandert wanneer je navigeert
      timeout={300}
      classNames="fade"
      unmountOnExit
    >
    <div className="page">

        <header style={{ borderBottom: '1px solid grey', position: 'relative' }}>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
              <button className="back-button" onClick={() => navigate(-1)}><img src={backicon} alt="Logo" style={{ height: '5vh', margin: '15px' }} /></button>
              <div className="configCompanies-title">{companyName}</div>

              <div style={{ position: 'relative' }}>
              <img src={icon_Help} className="selected-icon-variant-2" alt="Menu Help" style={iconStyle} title="Help & Support" onClick={handleMenu_Help} />
              <img src={icon_MyAccount} className="selected-icon-variant-2" alt="Menu 2" style={iconStyle} title="Account" onClick={() => setMenu2Open(!menu2Open)} />
              {menu2Open && (
                  <div ref={menu2Ref} style={{ ...popupMenuStyle, right: '20px', top: '8vh' }}>
                  <div style={{ color: 'grey', fontWeight: '500', textAlign: 'center', marginBottom: '2px' }}>{user?.name}</div>
                  <div style={{ color: 'grey', textAlign: 'center', marginBottom: '5px' }}>{user?.email}</div>
                  <div style={{ color: 'grey', textAlign: 'center', marginBottom: '5px', fontStyle: companyName ? 'normal' : 'italic' }}>
                      {companyName || 'No company assigned'}
                      {
                        user?.company_roleId && user?.company_roleId !== 3 && companyName && (
                          <a href={`/configcompany/${companyId}`}>
                            <img src={icon_ConfigCompany} alt="Configure company" title="Configure company" className="selected-icon" style={{ marginLeft: '10px', marginBottom: '3px', cursor: 'pointer', height: '17px', verticalAlign: 'middle' }} />
                          </a>
                        )
                      }
                  </div>            
                  <div style={{ borderBottom: '1px solid grey', marginBottom: '5px' }}></div>
                  <div className='menu-item' onClick={handleMyProfile}><div style={menuItemStyle}><img src={icon_MyProfile} alt="My profile" style={{ height: '3vh', margin: '0px 10px 0px 0px' }} /> My profile</div></div>
                  <div className='menu-item' onClick={handleSwitchCompany}><div style={menuItemStyle}><img src={icon_SwitchCompany} alt="Switch company" style={{ height: '3vh', margin: '0px 10px 0px 0px' }} /> Switch company</div></div>
                  <div className='menu-item' onClick={handleLogout}><div style={menuItemStyle}><img src={icon_Logout} alt="Log out" style={{ height: '3vh', margin: '0px 10px 0px 0px' }} /> Log out</div></div>
                  </div>
              )}
              </div>
          </div>
        </header>

        <div className="sidebar-cc">
            <div className="menu-item-cc" onClick={() => setActiveMenu('users')}>
                <span className={activeMenu === 'users' ? 'active' : ''}>Manage users</span>
            </div>
            <div className="menu-item-cc" onClick={() => setActiveMenu('reports')}>
                <span className={activeMenu === 'reports' ? 'active' : ''}>Manage reports</span>
            </div>
        </div>

        {showHelpPopup && (
          <div className="popup-container">
              <div className="popup-content">
              <h2 style={{ fontWeight: 'normal' }}>Request for support</h2>
              <div className="white-space"></div>
              <b>From:</b>
              <input
                  type="text"
                  placeholder="Username"
                  className="company-name-input"
                  disabled="true"
                  value={user.name || ""}
              />
              <b>Company:</b>
              <input
                  type="text"
                  placeholder="Company name"
                  className="company-name-input"
                  disabled="true"
                  value={companyName || ""}
              />
              <div style={{ display: 'inline-block', marginRight: '10px' }}>
                  <div style={{ height: '20px', display: 'inline-block', fontSize: '16px', marginRight: '10px' }}><b>Request category:</b></div>
                  <select 
                    style={{ display: 'inline-block', width: '150px' }}
                    value={selectedCategory}
                    onChange={(e) => setSelectedCategory(e.target.value)}
                >
                    <option value="Support">Support</option>
                    <option value="Customization request">Customization request</option>
                </select>
              </div>
              <div className="white-space"></div>
              <div className="white-space"></div>
              <b>Message:</b>
              <div className="white-space"></div>
              <textarea
                  placeholder="Request for support message"
                  className="company-name-input"
                  rows="4"
                  value={Request_message}
                  style={{ display: 'inline-block', maxHeight: '200px', minHeight: '200px', maxWidth: '100%', minWidth: '100%' }}
                  onChange={(e) => setRequestMessage(e.target.value)}
              ></textarea>
              <div style={{ height: '50px' }}></div>
              <div className="buttons-container">
                  <button onClick={() => setShowHelpPopup(false)} style={{ color: 'black', fontWeight: 'bold' }}>
                      Cancel
                  </button>
                  <button
                    onClick={handleSendHelpButton}
                    style={{ color: 'black', fontWeight: 'bold' }}
                  >
                  Send request
                  </button>
              </div>
              </div>
          </div>
        )}

        {showPopupMessage && <div className="popup-message">{message}</div>}
        {showErrorPopup && <div className="popup">{error}</div>}

    </div>
    </CSSTransition>
  );
}

export default ConfigCompany;